// ref: https://github.com/mui-org/material-ui/blob/master/LICENSE
// https://dev.to/namirsab/comment/2050
export const range = (start, end) => {
  const length = end - start + 1;
  return Array.from({
    length
  }, (_, i) => start + i);
};
export const getHref = (path, page) => {
  const pathPage = `page=${page}`;

  if (path.includes('page=')) {
    const [initialPath] = path.split('page=');
    if (page === 1) return initialPath.substring(0, initialPath.length - 1);
    return `${initialPath}${pathPage}`;
  }

  if (page === 1) return path;
  return path.includes('?') ? `${path}&${pathPage}` : `${path}?${pathPage}`;
};
export default function usePagination(props = {}) {
  const {
    boundaryCount: boundaryCountProp = 1,
    count = 1,
    disabled,
    path = '',
    page = 1,
    onChange,
    siblingCount = 1
  } = props;

  const handleClick = (event, value) => {
    onChange(event, value);
  };

  const boundaryCount = boundaryCountProp - 1;
  const startPages = range(1, Math.min(boundaryCount + 1, count));
  const endPages = range(Math.max(count - boundaryCount, boundaryCount + 2), count);
  const siblingsStart = Math.max(Math.min( // Natural start
  page - siblingCount, // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 2), // Greater than startPages
  boundaryCount + 3);
  const siblingsEnd = Math.min(Math.max( // Natural end
  page + siblingCount, // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 3), // Less than endPages
  endPages[0] - 2);
  const itemList = ['previous', ...startPages, // Start ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsStart > boundaryCount + 3 ? ['ellipsis'] : 2 + boundaryCount < count - boundaryCount - 1 ? [2 + boundaryCount] : []), // Sibling pages
  ...range(siblingsStart, siblingsEnd), // End ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsEnd < count - boundaryCount - 2 ? ['ellipsis'] : count - boundaryCount - 1 > boundaryCount + 1 ? [count - boundaryCount - 1] : []), ...endPages, 'next']; // Map the button type to its page number

  const pageByType = {
    first: 1,
    previous: page - 1,
    next: page + 1,
    last: count
  };
  const items = itemList.map(item => {
    return typeof item === 'number' ? {
      onClick: event => {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled,
      href: getHref(path, item),
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: event => {
        handleClick(event, pageByType[item]);
      },
      type: item,
      page: pageByType[item] || null,
      disabled: item === 'next' ? page >= count : page <= 1
    };
  });
  return {
    items
  };
}